<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<span #spectrumColorPickerElement><input class="input-small" /></span>
